import { render, staticRenderFns } from "./orderUrl.vue?vue&type=template&id=23ef5826"
import script from "./orderUrl.vue?vue&type=script&lang=js"
export * from "./orderUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports